module.exports = __webpack_public_path__ + "img/02_zhCn.18e0236a.png";